import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import clsx from "clsx";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Auth from "../../services/auth.service";
import { createTemporaryUser } from "../../services/user.service";
import { Redirect } from "react-router-dom";
import { TextField, Button, Typography } from "@material-ui/core";
import { success, error } from "../../services/toast.service";
import { capitalizeFirstLetter } from "../../utils/helperFunctions";
import { banners, logos } from "../../utils/contants";
import { FaFacebook, FaLinkedin, FaXTwitter, FaThreads, FaMastodon, FaBluesky } from "react-icons/fa6";
import KalemiBanner from "./KalemiBanner";

const renderIcon = (Icon: any, className: string) => React.createElement(Icon, { className });

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        overflow: "auto",
        height: "100vh",
        justifyContent: "space-between",
    },
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1,
        flexDirection: "column",
        maxWidth: "900px",
        marginTop: "14vh",
    },
    paper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginBottom: "0.5em",
    },
    h2: {
        fontWeight: 500,
        fontSize: "45px",
        fontFamily: "Source Sans Pro",
        color: theme.palette.secondary.main,
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "18px",
        },
    },
    h3: {
        fontSize: "25px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "15px",
        },
    },
    title: {
        fontWeight: 700,
        fontSize: "86px",
        fontFamily: "Source Sans Pro",
        color: theme.palette.primary.main,
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "35px",
            marginTop: "20px",
        },
    },
    form: {
        display: "flex",
        width: "80%",
        alignItems: "center",
        justifyContent: "center",
    },
    headerContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginBottom: "3em",
        [theme.breakpoints.down("xs")]: {
            marginBottom: "2em",
        },
    },
    button: {
        margin: 0,
        height: "60px",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        padding: "6px 24px",
        borderRadius: "0px 5px 5px 0px",
    },
    unitContainer: {
        backgroundColor: theme.palette.background.default,
        padding: "10px 24.5px",
        borderRadius: "5px",
        flexDirection: "column",
        width: "min-content",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2, 1.5),
        },
    },
    unitText: {
        color: theme.palette.secondary.main,
        fontSize: 15,
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
        },
    },
    timerText: {
        fontWeight: 700,
        fontSize: "40px",
        fontFamily: "Source Sans Pro",
        color: theme.palette.secondary.main,
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "25px",
        },
    },
    timerContainer: {
        display: "grid",
        "grid-template-columns": " repeat(4, min-content)",
        justifyItems: "center",
        gap: "4em",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            gap: "1em",
        },
    },
    field: {
        "& input": {
            background: "#F6FBFF",
            padding: "18px 14px",
            border: "1px solid #DDEAF2",
            fontFamily: "SOURCE SANS PRO",
        },
        "&: hover": {
            border: "none",
        },
        "& fieldset": {
            border: "none",
        },
    },
    subHeader: {
        color: theme.palette.secondary.main,
        fontSize: "20px",
        marginBottom: theme.spacing(3),
        textAlign: "center",
        maxWidth: "650px",
        [theme.breakpoints.down("sm")]: {
            margin: "2em 16px 1em 16px",
        },
    },
    iconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: "0.5em",
        marginRight: "0.5em",
    },
    defaultIcon: {
        padding: "1px",
        height: "25px",
        color: theme.palette.secondary.main,
        [theme.breakpoints.down("xs")]: {
            width: "19px",
            height: "17px",
        },
        top: "1px",
        position: "relative",
    },
    disabledBtn: {
        backgroundColor: "rgb(235, 240, 239) !important",
    },
    landingTop: {
        backgroundImage: `url(${banners.landingTop})`,
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundRepeat: "no-repeat",
        [theme.breakpoints.down("xs")]: {
            backgroundImage: `url(${banners.landingTopMobile})`,
        },
    },
    landingBottom: {
        height: "550px",
        width: "100%",
        background: `url(${banners.landingBottom}) no-repeat right 100%`,
        [theme.breakpoints.down("xs")]: {
            backgroundImage: `url(${banners.landingBottomMobile})`,
        },
    },
    logo: {
        backgroundImage: `url(${logos.kibo})`,
        backgroundRepeat: "no-repeat",
        width: "170px",
        height: "40px",
        [theme.breakpoints.down("xs")]: {
            backgroundImage: `url(${logos.kibo})`,
            width: "100px",
            height: "24px",
        },
    },
    publerLogo: {
        backgroundImage: `url(${logos.publer})`,
        backgroundRepeat: "no-repeat",
        width: "120px",
        height: "45px",
        marginLeft: "10px",
    },
    paragraph: {
        fontFamily: "Source Sans Pro",
        textAlign: "center",
        alignItems: "center",
        [theme.breakpoints.down("xs")]: {
            padding: "0 30px",
        },
    },
    flex: {
        display: "flex",
    },
    fbGroupLink: {
        textDecoration: "none",
        color: theme.palette.primary.main,
        "&: hover": {
            color: "rgba(6, 133, 240, 0.1)",
        },
    },
    groupDivider: {
        marginTop: "3em",
        [theme.breakpoints.down("xs")]: {
            marginTop: "3em",
        },
    },
    sectionDivider: {
        marginTop: "1em",
        [theme.breakpoints.down("xs")]: {
            marginTop: "1em",
        },
    },
    betaSection: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        gap: theme.spacing(2),
    },
    betaTitle: {
        color: theme.palette.secondary.main,
        fontSize: "18px",
        fontFamily: "Source Sans Pro",
        textAlign: "center" as const,
        marginBottom: theme.spacing(2),
    },
    signInBtn: {
        height: "50px",
        padding: "6px 40px",
        fontSize: "16px",
        fontFamily: "Source Sans Pro",
    },
    betaNotice: {
        color: theme.palette.secondary.main,
        fontSize: "14px",
        fontFamily: "Source Sans Pro",
        textAlign: "center" as const,
        opacity: 0.85,
        maxWidth: "420px",
        marginTop: theme.spacing(2),
    },
}));
export interface ITimer {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

const LAUNCH_DATE = new Date("2026-03-31T13:00:00Z");

const LandingPage = (props: any) => {
    const classes = useStyles();
    const history = useHistory();

    const status = props.location.state;

    const [email, setEmail] = useState<string>("");
    const [isFetching, setIsFetching] = useState<boolean>(false);
    useEffect(() => {
        if (status === "error") {
            error("There was an error activating the email!");
        }
    }, []);

    const calculateTimeLeft = () => {
        const currentDate = new Date();
        const currentDateUtc = Date.UTC(
            currentDate.getUTCFullYear(),
            currentDate.getUTCMonth(),
            currentDate.getUTCDate(),
            currentDate.getUTCHours(),
            currentDate.getUTCMinutes(),
            currentDate.getUTCSeconds()
        );
        const difference = +LAUNCH_DATE - +new Date(currentDateUtc);
        let timeLeft: ITimer = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState<ITimer>(calculateTimeLeft());
    const countdownPassed =
        timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0;

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearTimeout(timer);
    });

    const createUser = async (event: any) => {
        event.preventDefault();
        setIsFetching(true);
        try {
            await createTemporaryUser(email);
            success("Confirmation email was sent successfully!");
            setIsFetching(false);
        } catch (err: any) {
            if (err.response.data.status === "fail") {
                error(err.response.data.data.email);
            } else {
                error("This email is already registered!");
            }
            setIsFetching(false);
        }
    };

    if (Auth.isAuthenticated()) return <Redirect to={{ pathname: "workspace" }} />;

    return (
        <div className={classes.container}>
            <KalemiBanner />
            <div className={classes.landingTop} />

            <div className={classes.row}>
                <div className={classes.logo} />
                <div className={classes.headerContainer}>
                    <span className={classes.title}>Unified inbox</span>
                    <span className={classes.h2}>for Live chat, emails, messages,</span>
                    <span className={clsx(classes.h3, classes.h2)}>comments, mentions and reviews</span>
                </div>
                <div className={classes.headerContainer}>
                    {status === "success" ? (
                        <span className={classes.h3}>Email was successfully confirmed!</span>
                    ) : (
                        <span className={classes.h3}>{countdownPassed ? "We're in beta!" : "Coming very soon!"}</span>
                    )}
                </div>
                {!countdownPassed && (
                    <div>
                        <div className={classes.timerContainer}>
                            {Object.keys(timeLeft).map((interval, index) => {
                                return (
                                    <div className={clsx(classes.unitContainer, classes.paper)} key={index}>
                                        <div className={classes.unitText}>{capitalizeFirstLetter(interval)}</div>
                                        <div className={classes.timerText}>{timeLeft[interval as keyof ITimer]}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
                <div className={classes.groupDivider} style={countdownPassed ? { marginTop: 0 } : undefined}>
                    {countdownPassed ? (
                        <div className={classes.betaSection}>
                            <Typography className={classes.betaTitle}>
                                If you're part of the beta tester program
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.signInBtn}
                                onClick={() => history.push("/sign-in")}
                            >
                                Sign in
                            </Button>
                            <Typography className={classes.betaNotice}>
                                Check your email for your invitation if you have enrolled for the beta program.
                            </Typography>
                        </div>
                    ) : (
                        status !== "success" && (
                            <>
                                <div className={classes.paper}>
                                    <form className={classes.form} onSubmit={(event) => createUser(event)}>
                                        <TextField
                                            placeholder="Email address"
                                            required={true}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    root: classes.field,
                                                },
                                            }}
                                            value={email}
                                            onChange={(event) => setEmail(event.target.value)}
                                            variant="outlined"
                                            autoFocus
                                        />
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            className={classes.button}
                                            disabled={email === "" || isFetching}
                                            classes={{ disabled: classes.disabledBtn }}
                                        >
                                            subscribe
                                        </Button>
                                    </form>
                                </div>
                                <div className={clsx(classes.paragraph, classes.sectionDivider)}>
                                    Sign up to receive an invitation to the closed beta. Be among the very first users
                                    of Kibo, <br /> help us build the best unified inbox, and get rewarded.
                                </div>
                            </>
                        )
                    )}
                </div>
                <div className={classes.groupDivider}>
                    <div className={classes.paragraph}>
                        For more updates, join our{" "}
                        <a
                            className={classes.fbGroupLink}
                            href="https://www.facebook.com/groups/KiboConnect"
                            target="_blank"
                        >
                            support group
                        </a>{" "}
                        on Facebook or follow Kibo on social media
                    </div>
                    <div className={clsx(classes.paper, classes.sectionDivider)}>
                        <div className={clsx(classes.iconContainer)}>
                            <a href="https://facebook.com/kibohq" target="_blank">
                                {renderIcon(FaFacebook, clsx(classes.defaultIcon))}
                            </a>
                        </div>
                        <div className={clsx(classes.iconContainer)}>
                            <a href="https://www.linkedin.com/company/kibo-ai/" target="_blank">
                                {renderIcon(FaLinkedin, clsx(classes.defaultIcon))}
                            </a>
                        </div>
                        <div className={clsx(classes.iconContainer)}>
                            <a href="https://x.com/intent/user?screen_name=kibo_ai" target="_blank">
                                {renderIcon(FaXTwitter, clsx(classes.defaultIcon))}
                            </a>
                        </div>
                        <div className={clsx(classes.iconContainer)}>
                            <a href="https://www.threads.com/intent/follow?username=kibo.ai" target="_blank">
                                {renderIcon(FaThreads, clsx(classes.defaultIcon))}
                            </a>
                        </div>
                        <div className={clsx(classes.iconContainer)}>
                            <a href="https://mastodon.social/@kibo_ai" target="_blank">
                                {renderIcon(FaMastodon, clsx(classes.defaultIcon))}
                            </a>
                        </div>
                        <div className={clsx(classes.iconContainer)}>
                            <a href="https://bsky.app/profile/kibo.ai" target="_blank">
                                {renderIcon(FaBluesky, clsx(classes.defaultIcon))}
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    className={clsx(classes.paragraph, classes.flex, classes.groupDivider)}
                    style={{ fontWeight: "bold" }}
                >
                    From the creators of{" "}
                    <a href="https://publer.com" target="_blank">
                        <div className={classes.publerLogo} />
                    </a>
                </div>
            </div>
            <div style={{ width: "100%", marginTop: "-37vh" }}>
                <div className={classes.landingBottom} />
            </div>
        </div>
    );
};

export default withRouter(LandingPage);
